import React, { Component } from 'react';
import styles from './styles';

import { AxlPanel, AxlButton } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";

import { currencyOptions } from './validCurrencyCodes';
import CurrencyInput from '../CurrencyInput';
import AxlReactSelect from "../AxlReactSelect";




@inject('deliveryStore')
@observer
class ShipmentValueInfoForm extends Component {
  state = {
    updating: false,
  };

  componentDidMount() {
    const { deliveryStore, shipment } = this.props;
    const { shipmentValueInfoForm } = deliveryStore;
    const shipmentValue = (shipment && shipment.value) ? shipment.value : ''
    const shipmentCurrency = (shipment && shipment.currency) ? shipment.currency : ''

    shipmentValueInfoForm.setField('value', shipmentValue);
    shipmentValueInfoForm.setField('currency', shipmentCurrency);
  }

  closeWithoutSave = () => {
    this.props.closeForm();
  };

  save = (e) => {
    const {deliveryStore, shipment, closeForm} = this.props;
    this.setState({updating: true})
    deliveryStore.updateShipmentValue(shipment, (res) => {
      this.setState({updating: false})
      closeForm();
    });
  };

  canSave=()=>{
    const { deliveryStore } = this.props;
    const { shipmentValueInfoForm } = deliveryStore;
    const value = shipmentValueInfoForm.getField('value', '');
    const currency = shipmentValueInfoForm.getField('currency', '');

    if(value == '' && currency != ''){
      return false;
    }

    if(value != '' && currency == ''){
      return false;
    }    

    return true;
  }

  render() {
    const { deliveryStore } = this.props;
    const { shipmentValueInfoForm } = deliveryStore;
    const enableSave = this.canSave();
    const currentCurrencyValue = currencyOptions.find(c=>c.value === shipmentValueInfoForm.getField('currency', ' '));

    return <div style={styles.Container}>
      <div style={styles.HeaderTitle}>{`Edit Shipment Value`}</div>
      <AxlPanel>
        <AxlPanel.Row>
            <AxlPanel.Col style={styles.GroupPanel}>
              <AxlPanel.Row align={`center`}>
                <AxlPanel.Col>
                <div style={styles.GroupTitle}>{`Value`}</div>          

                <div style={styles.Field}>
                    <CurrencyInput style={{...styles.moneyInput}} 
                    type="text"                    
                    value={shipmentValueInfoForm.getField('value', '')}
                    onChange={shipmentValueInfoForm.handlerInput}  
                    name='value'
                    required
                    />                    
                  </div>
                </AxlPanel.Col> 
              </AxlPanel.Row>            
            </AxlPanel.Col>           
        </AxlPanel.Row>
        <AxlPanel.Row>
            <AxlPanel.Col style={styles.GroupPanel}>
              <AxlPanel.Row align={`center`}>
              <AxlPanel.Col>
              <div style={styles.GroupTitle}>{`Currency`}</div>                               
              <div>
                <AxlReactSelect
                name='currency'
                options={currencyOptions}
                value={currentCurrencyValue}
                maxMenuHeight="350"
                onChange={(selected)=>{
                  shipmentValueInfoForm.setField('currency',selected.value)}
                }
              />
              </div>
              </AxlPanel.Col> 
              </AxlPanel.Row>            
            </AxlPanel.Col>           
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <AxlPanel.Row align={`flex-end`}>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`gray`}
                           onClick={this.closeWithoutSave}
                           style={styles.buttonControl}
                >
                  {`Cancel`}
                </AxlButton>
              </div>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`pink`}
                           onClick={this.save}
                           style={styles.buttonControl}
                           loading={this.state.updating}
                           disabled={!enableSave}
                >
                  {`Save`}
                </AxlButton>
              </div>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </div>
  }
}

export default ShipmentValueInfoForm;